import React, { useState } from 'react';
import {
  Grid,
  Typography,
  FormControlLabel,
  Checkbox,
  colors
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectCraftData,
  selectLocations,
  selectShowSitl
} from 'selectors/liveAircraftSelectors';

import { AircraftList } from './components/Aircraft/AircraftList';
import { chooseLocation, toggleShowSitl } from 'actions/liveAircraftActions';
import { Disclosure } from '@headlessui/react';
import { MinusSmallIcon, PlusSmallIcon } from '@heroicons/react/20/solid';

export const CraftList = () => {
  const uavs = useSelector(selectCraftData);
  const locations = useSelector(selectLocations);
  const showSitl = useSelector(selectShowSitl);

  const dispatch = useDispatch();

  const onChangeSitl = () => {
    dispatch(toggleShowSitl());
  };

  const onClickLocation = location => {
    dispatch(chooseLocation(location));
  };

  return (
    <Disclosure>
      {({ open }) => (
        <Grid
          container
          item
          direction="column"
          spacing={'4px'}
          className="w-72 h-full">
          <Disclosure.Button className="flex w-full items-start justify-between text-left text-gray-900 p-4">
            <span className="text-base font-semibold leading-7">Active Craft</span>
            <span className="ml-6 flex h-7 items-center">
              {open ? (
                <MinusSmallIcon className="h-6 w-6" aria-hidden="true" />
              ) : (
                <PlusSmallIcon className="h-6 w-6" aria-hidden="true" />
              )}
            </span>
          </Disclosure.Button>
          <Disclosure.Panel>
            <Grid item className="ml-4 h-10">
              <FormControlLabel
                onChange={onChangeSitl}
                control={
                  <Checkbox color="primary" checked={showSitl} value={showSitl} />
                }
                label="Show SITL"
              />
            </Grid>
            <Grid item container direction="column">
              {locations.map(location => {
                const uavsInLocation = uavs
                  .filter(uav => uav?.location?.name === location)
                  .filter(uav => {
                    if (showSitl) {
                      return true;
                    } else {
                      return !uav?.sitl;
                    }
                  });
                const loc = uavs.filter(uav => uav?.location?.name === location)?.[0]
                  ?.location;

                if (!location) return null;
                return (
                  <Grid
                    item
                    key={location}
                    container
                    direction="column"
                    className="hover:scale-95 cursor-pointer"
                    onClick={() => onClickLocation(loc)}>
                    <Grid item className="p-4 bg-gray-50">
                      <Typography variant={'h5'}>{`${location
                        ?.slice(0, 1)
                        .toUpperCase()}${location?.slice(1)}`}</Typography>
                    </Grid>
                    <AircraftList uavs={uavsInLocation} />
                  </Grid>
                );
              })}
            </Grid>
          </Disclosure.Panel>
        </Grid>
      )}
    </Disclosure>
  );
};
